/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// English (United Kingdom)
export default {
    'fabric.atlassianSwitcher.switchTo': 'Switch to',
    'fabric.atlassianSwitcher.switchToTooltip': 'Switch to…',
    'fabric.atlassianSwitcher.recent': 'Recent',
    'fabric.atlassianSwitcher.more': 'More',
    'fabric.atlassianSwitcher.try': 'Try',
    'fabric.atlassianSwitcher.manageList': 'Manage list',
    'fabric.atlassianSwitcher.jiraProject': 'Jira project',
    'fabric.atlassianSwitcher.confluenceSpace': 'Confluence space',
    'fabric.atlassianSwitcher.people': 'People',
    'fabric.atlassianSwitcher.administration': 'Administration',
    'fabric.atlassianSwitcher.discoverMore': 'More Atlassian products',
    'fabric.atlassianSwitcher.errorHeading': 'Something’s gone wrong',
    'fabric.atlassianSwitcher.errorText': 'We keep track of these errors, but feel free to contact us if refreshing doesn’t fix things',
    'fabric.atlassianSwitcher.errorImageAltText': 'A broken robot and a number of people busy fixing it.',
    'fabric.atlassianSwitcher.expand': 'Expand',
};
//# sourceMappingURL=en_GB.js.map